// @flow

export default class IncludedServices {
  light: boolean;
  gas: boolean;
  water: boolean;
  cable: boolean;
  wifi: boolean;
  cleaning_service: boolean;

  constructor(data: any = {}) {
    this.light = data.light;
    this.gas = data.gas;
    this.water = data.water;
    this.cable = data.cable;
    this.wifi = data.wifi;
    this.cleaning_service = data.cleaning_service;
  }
}
